import { Strong } from '@ahmdigital/ui';
import React from 'react';

import { percentages } from '../../constants';
import styles from './styles.module.sass';

// @ts-expect-error - Automatic, Please fix when editing this file
const tipFormatter = (value) => (
  <div>
    {/* @ts-expect-error - Automatic, Please fix when editing this file */}
    <Strong variant={[styles.tooltip]}>{(percentages[value] || 0) * 100}%</Strong>
    <div className={styles.tooltipTitle}>
      youth <br />
      discount
    </div>
  </div>
);

export default tipFormatter;
